/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/** Instance branding also works on error screens before Matrix config loads. */
export function getProductName(): string {
  return import.meta.env.VITE_PRODUCT_NAME?.trim() || window.location.hostname;
}
